/**
 * This must be in sync with the UCC.php in ubercart module
 */

class CartItem {
    public id_cabinet: number = -1;
    public cartAction: string = "";
    public Name: string = "";
    public count: number = 0;
    public Price: number = 0;
    public Dimensions: string = "";
    public children: any[] = []; // TODO: Type this
    public uconScript: any[] = []; // TODO: Type this
    public descriptor: any[] = []; // TODO: Type this
}

export default CartItem;
